<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 v-if="regData.status != 'M'" class="page_title --view">제품코드 등록</h2>
          <h2 v-if="regData.status == 'M'" class="page_title --view">제품코드 수정</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">약재명</span></th>
                  <td>
                    <div class="form_inline">
                      <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.medHrbNm" :readonly="this.regData.status == 'M'">
                      <button v-if="this.regData.status != 'M'" class="btn btn_md btn_deepblue" v-b-modal.medicineSearch01>검색</button>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                  <th><span>원산지</span></th>
                  <td>{{regData.orgPlceNm}}</td>
                </tr> -->
                <tr>
                  <th><span class="emp">제약회사</span></th>
                  <td>
                      <!-- <div class="form_select">
                      <b-form-select v-model="regData.pharmaceuticalCompany" >
                        <b-form-select-option value="">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in pharmaceuticalCompanyList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                      </div> -->
                      <div class="form_inline">
                      <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.companyNm">
                      <button class="btn btn_md btn_deepblue" v-b-modal.companyListSearch>검색</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">제품코드</span></th>
                  <td><input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.productCd" ></td>
                </tr>
                <tr>
                  <th><span>정렬순서</span></th>
                  <td><input type="text" class="form_control limit" placeholder="숫자만 입력해주세요." v-model="regData.orderNum" maxlength="4" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></td>
                </tr>         
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <SearchModal01 
        :title="'약재 검색'" 
        :searchName="'약재명'"
        :searchData="regData.medHrbNm"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_callback"
      />
      <SearchCompanyModal 
        :title="'제약회사 검색'" 
        :searchName="'제약회사'"
        :searchData="regData.companyNm"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_company_callback"
      />
    </div>
</template>

<script>
	import axios from 'axios'
  import commonUtil from "@/mixin/commonUtil";
	import Datepicker from '@/components/Datepicker.vue'
	import SearchModal01 from "@/modal/admin/medicineSearch01.vue"
  import SearchCompanyModal from "@/modal/admin/companyListSearch.vue"

	export default {
		name: 'MedicineWrhsMngtReg',
		components: {
      Datepicker,
      SearchModal01,
      SearchCompanyModal
		},
    mixins: [commonUtil],
		data() {
            return {
                selected: null,
                productCodeList : [],
                chkProductCode : true,
                regData : {
                    medHrbCd : "",
                    medHrbNm : "",
                    //medHrbDtlSeq : "",
                    //orgPlceNm : "",
                    companyCd : "",
                    companyNm : "",
                    productCd : "",
                    orderNum : '',
                    productCodeUuid : '',
                    status : '',
                },
		    }
		},
    created(){
      this.regData.status = this.$store.getters['medicine/getStatus'];
    },
    mounted(){
        if(this.regData.status == 'M'){
            this.fn_search(); 
        }
    },
		methods : {
			fn_callback (medObject){
          this.regData.medHrbCd = medObject.med_hrb_cd;
          this.regData.medHrbNm = medObject.med_hrb_nm;
          this.fn_pre_check();
			},
      fn_company_callback(companyObject){
        this.regData.companyCd = companyObject.companyCd;
				this.regData.companyNm = companyObject.companyNm;

        this.fn_pre_check();
      },
			fn_move_page(){
        this.$store.dispatch('medicine/setStatus', '');
				this.$store.dispatch('medicine/setProductCodeUuid', '');
				this.$router.push("/admin/medicine/productCodeMngt");
			},
			fn_reg(){

        if(this.regData.medHrbCd == ''){
          alert("약재정보를 입력하세요");
          return;
        }

        if(this.regData.companyCd == ''){
          alert("회사정보를 입력하세요");
          return;
        }

        if(this.regData.productCd == ''){
          alert("제품코드를 입력하세요");
          return;
        }

        if(this.chkProductCode){
					axios
            .post("/api/medicine/regProductCode", this.regData)
            .then((res) => {
              
              alert("저장되었습니다");
              this.fn_move_page();
            })
				    .catch((err) => console.log(err));
        }else{
          alert("이미 등록된 제품코드가 있습니다.");
        }			
			},
      fn_search(){

        let param = new Object();
        param.productCodeUuid = this.$store.getters['medicine/getProductCodeUuid'];

        axios
            .post("/api/medicine/getProductCodeInfo", param)
            .then((res) => {
                console.log("@@@@ dtl res data : %o",res.data);
                
                this.regData.productCodeUuid = res.data.product_code_uuid;
                this.regData.medHrbCd = res.data.med_hrb_cd;
                this.regData.medHrbNm = res.data.med_hrb_nm;
                this.regData.orgPlceNm = res.data.org_plce_nm;
                this.regData.companyCd = res.data.companyCd;
                this.regData.companyNm = res.data.companyNm;
                this.regData.productCd = res.data.product_code;

                if(res.data.order_num == '9999'){
                  this.regData.orderNum = '';
                }else{
                  this.regData.orderNum = res.data.order_num;
                }


                this.regData.medHrbDtlSeq = res.data.med_hrb_dtl_seq;
                
                console.log("@@@@ dtl this.regData : %o",this.regData);

            })
            .catch((err) => console.log(err));
            
      },
      fn_calculate_price(){

        if(this.regData.wrhsPrice != "" && this.regData.wrhsPrice > 0){
          let gunboPrice = this.regData.wrhsPrice / this.regData.wrhsQnty;
          
          let stabdPrice = gunboPrice * 1.3;

          this.regData.gunboPrice = gunboPrice;
          this.regData.standPrice = stabdPrice;
        }
      },
      fn_pre_check(){

        console.log("@@@@ fn_pre_check");

        if(this.regData.medHrbCd != '' && this.regData.companyCd != ''){

          console.log("@@@@ fn_pre_check gogo");

          let param = new Object();
          param.medHrbCd = this.regData.medHrbCd;
          param.companyCd = this.regData.companyCd;

          axios
            .post("/api/medicine/preChkProductCode", param)
            .then((res) => {
                console.log("@@@@ dtl res chkResult : %o",res.data.chkResult);
                
                if(res.data.chkResult != "ok"){
                  alert("이미 등록된 제품코드가 있습니다.");
                  this.chkProductCode = false;
                }else{
                  this.chkProductCode = true;
                }

            })
            .catch((err) => console.log(err));

        }
      }
		}
	}
</script>